// extracted by mini-css-extract-plugin
export default {"newProjectModal":"css_newProjectModal__d1W8w","title":"css_title__5JNu1","selectsList":"css_selectsList__pA7HD","buttons":"css_buttons__why2g"};